var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Page',{attrs:{"title":"Activities"}},[_c('YearSelector',{on:{"select":_vm.load}}),_c('LeadList',{staticClass:"my-5",attrs:{"items":_vm.leads}}),_c('OpportunityList',{staticClass:"my-5",attrs:{"items":_vm.opportunities}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }